import React from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Flex, Avatar, Text, Link } from "@radix-ui/themes";
import { ImageIcon, FileIcon } from "@radix-ui/react-icons";

dayjs.extend(relativeTime);

interface FileMessageComponenttProps {
  url: string;
  filename: string;
  createdAt: string;
  showTimestamp: boolean;
  orientation: "left" | "right";
  isLastMessage: boolean;
  thinking: boolean;
}

export function FileMessageComponent({
  url,
  filename,
  createdAt,
  showTimestamp,
  orientation,
  isLastMessage,
  thinking,
}: FileMessageComponenttProps) {
  const isImg = url.match(/\.(jpeg|jpg|gif|png)$/) != null;

  return (
    <Flex
      {...(orientation === "right"
        ? { pr: "36px", direction: "row-reverse", align: "end" }
        : { pl: "36px", direction: "row", align: "start" })}
      gap={"3"}
    >
      <Flex direction={"column"} align={"start"} gap={"2"}>
        <Link href={url} target="_blank" rel="noreferrer">
          <Flex
            gap={"10px"}
            align={"center"}
            style={{
              padding: "4px 8px 4px 4px",
              borderRadius: "8px",
              background: "var(--gray-a3)",
            }}
          >
            {isImg ? (
              <Avatar
                size={"2"}
                color={"gray"}
                src={url}
                fallback={<ImageIcon width={"24"} height={"24"} />}
                alt="File Image"
              />
            ) : (
              <Avatar
                size={"2"}
                color={"indigo"}
                variant={"solid"}
                src={url}
                fallback={<FileIcon width={"24"} height={"24"} />}
                alt="File Icon"
              />
            )}

            <Text
              size={"3"}
              color={"gray"}
              highContrast
              truncate
              style={{ maxWidth: "120px" }}
            >
              {filename}
            </Text>
          </Flex>
        </Link>

        {showTimestamp && (
          <Text size={"1"} color={"gray"}>
            {dayjs().diff(dayjs(createdAt), "day") > 1
              ? dayjs(createdAt).format("hh:mm:ss A")
              : dayjs(createdAt).fromNow()}
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
